import { Component, OnInit, OnDestroy } from '@angular/core'
import { Observable, Subscription } from 'rxjs'
import { ChartPart } from 'src/app/models/chart.model'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { getChartTiktokWeeklyInfo, getAllEmpty, getLoading } from 'src/app/selectors/chart.selector'
import { MediaObserver, MediaChange } from '@angular/flex-layout'
import {
  getDataCollectByChartsTiktok,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-chart-item-tiktok',
    templateUrl: './chart-item-tiktok.component.html',
    styleUrls: ['./chart-item-tiktok.component.scss'],
    standalone: false
})
export class ChartItemTiktokComponent implements OnInit, OnDestroy {
  tiktokWeeklyInfo$: Observable<ChartPart[]>
  loading$: Observable<boolean>
  allEmpty$: Observable<boolean>
  private subscriptions: Subscription[] = []

  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(public media: MediaObserver, private store: Store<AppState>) {
    this.subscriptions.push(media.asObservable().subscribe(() => {}))
  }

  ngOnInit() {
    this.tiktokWeeklyInfo$ = this.store.select(getChartTiktokWeeklyInfo)
    this.loading$ = this.store.select(getLoading)
    this.allEmpty$ = this.store.select(getAllEmpty)

    this.dataCollections$ = this.store.select(getDataCollectByChartsTiktok)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }
  ngOnDestroy() {
    this.subscriptions.forEach(it => it.unsubscribe())
  }
}
